import { BFV_J9, IGlobalData, TempVaraktighet } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleLokaler, IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";
import { IModuleRound, IRoundHandler } from "../roundHandler";
import { IBFModule, IBFResult, IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";
import { bflHelper } from "./bflHelper";
import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { logAndNotifyError } from "../logger";
import { numFrmt2Dec, numFrmt3Dec } from "../common";

//todo -> make class?!
export const bfv_J9 = (): IBFModule => {
  const bfName = BFLType.BFV_J9;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData, formData: any): IBFResult => {
    let funktionsKontroller: IKontrollResultRow[] = [];
    let driftOptimeringar: IKontrollResultRowDriftoptimering[] = [];
    let data: any = {};
    let dbg = {} as any;
    let error: any = undefined;
    const bH = bflHelper();
    try {
      const moduleData = module.data as IModuleVattenburetSekundärsystem;
      const parallellFörskjutning = moduleData.parallellforskjutning || 0.0;
      const normalårsTemperaturOmråde = bimHandler.normalårsTemperaturOmråde;

      formData = (formData?.data || module.bfs?.BFV_J9?.data) as BFV_J9 | undefined;
      const parallellFörskjutningNy =
        formData?.parallellFörskjutningNy !== undefined && formData?.parallellFörskjutningNy !== null ? formData.parallellFörskjutningNy : parallellFörskjutning;

      const tableName = "tempFordelning_" + normalårsTemperaturOmråde.replaceAll("-", "_").replaceAll(" ", ""); //tempFordelning_4_6
      const tempInfoTable = (globalData.BFV_J9 as any)[tableName] as TempVaraktighet[];

      //Meddelande FKText6 prametrar. Är värme och kyla aktiv sammtidigt
      let ärKylaAktiv = false;
      const pumpIDrift = moduleData.pumpstoppKontroll === "PUMP I DRIFT";

      const lokalerModule = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Lokaler);
      const lokalerModuleData = lokalerModule?.data as IModuleLokaler;

      const anyRowsWhenKylaAktivt = lokalerModuleData.stickprov.filter((r) => r.värmeSystem === module.name && r.komfortKylaAktiv === "Ja");
      ärKylaAktiv = anyRowsWhenKylaAktivt.length > 0 ? true : false;

      let maxFramledningsTemperatur = 0;
      let summaEnergiFaktor = 0;
      let summaEnergiFaktorNy = 0;

      const värmekurvaData = moduleData.värmekurva;

      //const värmekurva = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => {
      const dbgVärmekurva: any = {};
      const dbgVärmekurvaNy: any = {};
      const värmekurva = värmekurvaData.map((kurva: any, i: number) => {
        const ret = {} as {
          brytpunktUtetemp: number;
          brytpunktUtetempNy: number | undefined;
          brytpunktFramledningstemp: number;
          brytpunktFramledningstempNy: number | undefined;
          brytpunktFramledningstempKomp: number;
          brytpunktFramledningstempKompNy: number | undefined;
          varaktighet: number;
          varaktighetNy: number | undefined;
          energiFaktor: number;
          energiFaktorNy: number | undefined;
        };
        ret.brytpunktUtetemp = moduleData.värmekurva[i].brytpunktUtetemp || 0;
        ret.brytpunktFramledningstemp = moduleData.värmekurva[i].brytpunktFramledningstemp || 0;
        ret.brytpunktFramledningstempKomp = ret.brytpunktFramledningstemp + parallellFörskjutning;
        ret.varaktighet = tempInfoTable.find((r) => r.Utetemp === ret.brytpunktUtetemp)?.["Andel / °C"] || 0;
        ret.energiFaktor =
          ret.brytpunktFramledningstempKomp !== undefined && ret.brytpunktFramledningstempKomp !== null && ret.varaktighet !== undefined && ret.varaktighet !== null
            ? (ret.brytpunktFramledningstempKomp - ret.brytpunktUtetemp) * ret.varaktighet
            : 0;

        if (formData?.värmekurva && formData?.värmekurva.find((r: any) => r.brytpunktUtetempNy && r.brytpunktFramledningstempNy)) {
          if (formData.värmekurva.length > i) {
            ret.brytpunktUtetempNy = formData.värmekurva[i].brytpunktUtetempNy || 0;
            ret.brytpunktFramledningstempNy = formData.värmekurva[i].brytpunktFramledningstempNy;

            ret.brytpunktFramledningstempKompNy = ret.brytpunktFramledningstempNy + parallellFörskjutningNy;

            ret.varaktighetNy = tempInfoTable.find((r) => r.Utetemp === ret.brytpunktUtetempNy)?.["Andel / °C"] || 0;
            ret.energiFaktorNy =
              ret.brytpunktFramledningstempKompNy !== undefined && ret.brytpunktFramledningstempKompNy !== null && ret.varaktighetNy !== undefined && ret.varaktighetNy !== null
                ? (ret.brytpunktFramledningstempKompNy - (ret.brytpunktUtetempNy || 0)) * ret.varaktighetNy
                : 0;
          } else {
            ret.brytpunktUtetempNy = ret.brytpunktUtetemp;
            ret.brytpunktFramledningstempNy = ret.brytpunktFramledningstemp;

            ret.brytpunktFramledningstempKompNy = ret.brytpunktFramledningstempKomp;

            ret.varaktighetNy = ret.varaktighet;
            ret.energiFaktorNy = ret.energiFaktor;
          }
        } else {
          ret.brytpunktUtetempNy = ret.brytpunktUtetemp;
          ret.brytpunktFramledningstempNy = ret.brytpunktFramledningstemp;

          ret.brytpunktFramledningstempKompNy = ret.brytpunktFramledningstempNy + parallellFörskjutningNy;

          ret.varaktighetNy = tempInfoTable.find((r) => r.Utetemp === ret.brytpunktUtetempNy)?.["Andel / °C"] || 0;
          ret.energiFaktorNy =
            ret.brytpunktFramledningstempKompNy !== undefined && ret.brytpunktFramledningstempKompNy !== null && ret.varaktighetNy !== undefined && ret.varaktighetNy !== null
              ? (ret.brytpunktFramledningstempKompNy - ret.brytpunktUtetempNy) * ret.varaktighetNy
              : 0;
        }
        dbgVärmekurva["punkt " + i + "_varaktighet"] = numFrmt2Dec.format(ret.varaktighet * 100) + " %";
        dbgVärmekurvaNy["punkt " + i + "_varaktighet"] = numFrmt2Dec.format(ret.varaktighetNy * 100) + " %";
        dbgVärmekurva["punkt " + i + "_energiFaktor"] = ret.energiFaktor ? numFrmt3Dec.format(ret.energiFaktor) : 0;
        dbgVärmekurvaNy["punkt " + i + "_energiFaktor"] = ret.energiFaktorNy ? numFrmt3Dec.format(ret.energiFaktorNy) : 0;
        summaEnergiFaktor += ret.energiFaktor;
        summaEnergiFaktorNy += ret.energiFaktorNy;

        if (maxFramledningsTemperatur < ret.brytpunktFramledningstemp) maxFramledningsTemperatur = ret.brytpunktFramledningstemp;
        return ret;
      });

      dbgVärmekurva["Summa energiFaktor"] = summaEnergiFaktor ? numFrmt3Dec.format(summaEnergiFaktor) : 0;
      dbgVärmekurvaNy["Summa energiFaktor"] = summaEnergiFaktorNy ? numFrmt3Dec.format(summaEnergiFaktorNy) : 0;

      dbg["Värmekurva"] = dbgVärmekurva;
      dbg["Värmekurva ny"] = dbgVärmekurvaNy;

      const schablonBesparing = globalData.BFV_J9.BesparingTemperaturIntervall.find((r) => r.MinTemp <= maxFramledningsTemperatur && maxFramledningsTemperatur < r.MaxTemp)
        ?.Besparing as number;

      const förändringVärmekurva = (summaEnergiFaktor - summaEnergiFaktorNy) / summaEnergiFaktor;
      const årligEnergiTransmission = bimHandler.BIM_ÅrligBruttoTransmission();
      const shuntensSystemAndel = moduleData.värmeSystemandel / 100;
      // const värmekälla = bimHandler.energiKälla;
      const vägledande_Verkningsgrad = bimHandler.BIM_Vägledande_VerkninsgradAktuellVärmekälla;
      // const normalårsTemperatur = bimHandler.normalårsTemperatur;
      const överkonsumtionTransmissionPerGradInomhus = 0.05; //Todo : Move to settings in GlobalData

      const besparingNykurva = (förändringVärmekurva * årligEnergiTransmission * shuntensSystemAndel) / vägledande_Verkningsgrad;
      const besparingTyp = bimHandler.värmeKällaInfo?.BFV_J9_Typ; //"Värme"  / "El värme"
      const energiSlag = bimHandler.energiSlag;

      const temperaturUtegivare = moduleData.utegivareTemperatur;

      const myStickprovs = bimHandler.getStickprovsMätningarFörVärmesystem(module.name);
      let uppmättMedeltemperatur = 0;
      let uppmättMintemperatur = 0;
      let uppmättMaxtemperatur = 0;
      if (myStickprovs.length) {
        uppmättMedeltemperatur = myStickprovs.reduce((agg, cur) => agg + cur.uppmättTemperatur, 0.0) / myStickprovs.length;
        uppmättMintemperatur = myStickprovs.reduce((agg, cur) => (cur.uppmättTemperatur < agg ? cur.uppmättTemperatur : agg), Number.MAX_VALUE);
        uppmättMaxtemperatur = myStickprovs.reduce((agg, cur) => (cur.uppmättTemperatur > agg ? cur.uppmättTemperatur : agg), Number.MIN_VALUE);
      }

      const verksamhet = bimHandler.verksamhet;
      const rekommenderadMedelTemperatur = bimHandler.verksamhetInfo?.RekommenderadMedelTemperatur || NaN;
      const diffUppmättMotRekommenderat = uppmättMedeltemperatur - rekommenderadMedelTemperatur;
      const uppmättTempDiff = uppmättMaxtemperatur - uppmättMintemperatur;

      const isNotOptimised = temperaturUtegivare <= 20 && diffUppmättMotRekommenderat > 0.49;
      const överkonsumtion = isNotOptimised
        ? (diffUppmättMotRekommenderat * årligEnergiTransmission * shuntensSystemAndel * överkonsumtionTransmissionPerGradInomhus) / vägledande_Verkningsgrad
        : 0;

      dbg["Grundvärden"] = {
        förändringVärmekurva,
        årligEnergiTransmission,
        shuntensSystemAndel,
        värmekälla: bimHandler.energiKälla,
        vägledande_Verkningsgrad,
        överkonsumtionTransmissionPerGradInomhus,
        besparingNykurva,
        besparingTyp,
        överkonsumtion,
        temperaturUtegivare,
      };

      // if (överkonsumtion && överkonsumtion > 0) {
      if (temperaturUtegivare <= 20 && diffUppmättMotRekommenderat >= 0.49) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, överkonsumtion, energiSlag));
        // funktionsKontroller.push({
        //   index: 1,
        //   kWhs: överkonsumtion,
        //   energiSlag: energiSlag,
        //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ9_FKText1, // "Avvikelse hög medeltemperatur i lokaler orsakar överkonsumtion av energi. Justera värmekurva framledning - se vägledning.",
        // });
      } else {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 2, undefined, ""));
        // funktionsKontroller.push({
        //   index: 2,
        //   kWhs: "",
        //   energiSlag: "",
        //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ9_FKText2, //"Värmekurva framledning är energioptimerad.",
        // });
      }

      if (uppmättTempDiff > 2) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 3, undefined, ""));
        // funktionsKontroller.push({
        //   index: 3,
        //   kWhs: "",
        //   energiSlag: "",
        //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ9_FKText3, //"Ojämna rumstemperaturer- kontrollera värmesystem- se vägledning.",
        // });
      } else {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, undefined, ""));
        // funktionsKontroller.push({
        //   index: 4,
        //   kWhs: "",
        //   energiSlag: "",
        //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ9_FKText4, // "Rumstemperaturer är jämna.",
        // });
      }

      if (ärKylaAktiv && pumpIDrift) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 6, undefined, ""));
      }

      if (besparingTyp && Math.abs(besparingNykurva) > 0.1) {
        if (besparingNykurva < 0) {
          driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 2, Math.abs(besparingNykurva), energiSlag));
          // driftOptimeringar.push({
          //   index: 2,
          //   kWhs: Math.abs(besparingNykurva),
          //   energiSlag: energiSlag,
          //   message: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ9_OptText2.Text, //"Ökad användning värme med ny värmekurva."
          //   inverteraTecken: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ9_OptText2.InverteraTecken,
          // });
        } else {
          driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 1, Math.abs(besparingNykurva), energiSlag));
          // driftOptimeringar.push({
          //   index: 1,
          //   kWhs: Math.abs(besparingNykurva),
          //   energiSlag: energiSlag,
          //   message: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ9_OptText1.Text, //"Besparingspotential  värme med ny värmekurva."
          //   inverteraTecken: globalData.Driftoptimeringar.mapDriftoptimeringar.BFVJ9_OptText1.InverteraTecken,
          // });
        }
      } else {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, undefined, ""));
        // funktionsKontroller.push({
        //   index: 5,
        //   kWhs: "",
        //   energiSlag: "",
        //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ9_FKText5, //"Värmekurva oförändrad / Ingen effekt.",
        // });
      }

      if (!värmekurva.find((r) => r.brytpunktUtetemp && r.brytpunktUtetempNy)) {
        error = "Värmekurva saknar värden";
      }
      data = {
        parallellFörskjutning: parallellFörskjutning,
        parallellFörskjutningNy,
        schablonBesparing: schablonBesparing,
        värmekurva: värmekurva,
        stickprov: {
          HögstUppmätt: uppmättMaxtemperatur,
          LägstUppmätt: uppmättMintemperatur,
          MedelUppmätt: uppmättMedeltemperatur,
        },
        temperaturInfo: {
          verksamhet,
          uppmättMedeltemperatur,
          rekommenderadMedelTemperatur,
          uppmättTempDiff,
          diffUppmättMotRekommenderat,
        },
      };
      return {
        bfName: BFLType.BFV_J9,
        funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
        driftOptimeringar: bH.cleanDriftoptimeringar(driftOptimeringar),
        data: data,
        note: "",
        error: error,
        debug: dbg,
      };
    } catch (err: any) {
      return {
        bfName,
        funktionsKontroller: [],
        driftOptimeringar: [],
        note: "",
        data: {},
        debug: { Error: err },
        error: err,
      };
    }
  };

  /// transfers any formdata values to the värmekurva.
  const bflSpecificPrepareData = (module: IModuleRound, bfl: IBFResult, bflForm: IBFResult | undefined) => {
    if (bfl?.data?.värmekurva && bflForm?.data?.värmekurva) {
      const copyUntilIndex = bfl.data.värmekurva.length > bflForm.data.värmekurva.length ? bflForm.data.värmekurva.length : bfl.data.värmekurva.length;

      for (var i = 0; i < copyUntilIndex; i++) {
        const rowDataForm = bflForm.data.värmekurva[i];
        const rowData = bfl.data.värmekurva[i];
        if (rowData.brytpunktFramledningstempNy !== rowDataForm.brytpunktFramledningstempNy || rowData.brytpunktUtetempNy !== rowDataForm.brytpunktUtetempNy) {
          rowData.brytpunktUtetempNy = rowDataForm.brytpunktUtetempNy;
          rowData.brytpunktFramledningstempNy = rowDataForm.brytpunktFramledningstempNy;
        }
      }

      bfl.data.parallellFörskjutningNy = bflForm.data.parallellFörskjutningNy;
    }
  };

  //module public interface
  return {
    getResult: getResult,
    bflSpecificPrepareData,
    bfName,
  };
};

const dflt = { bfv_J9 };

export default dflt;
